import {createSelector} from '@ngrx/store';
import {getOrderState} from './order.reducer';

export const selectEstimatedCosts = createSelector(
	getOrderState,
	orderState => orderState.estimatedCosts || null
);
